export default __webpack_public_path__ + "ff03c6e92527abfb1720eb9425f3f4ca.woff2";